//@ts-nocheck
export const isFileTypeAndExtensionAllowed = (
  file,
  acceptedMimeTypes = [],
  acceptedExtensions = []
) => {
  if (!acceptedMimeTypes.length && !acceptedExtensions.length) {
    return true;
  }

  const fileType = file?.type?.toLowerCase() ?? '';
  const fileName = file?.name?.toLowerCase() ?? '';
  const mimeTypeAllowed =
    !acceptedMimeTypes.length ||
    acceptedMimeTypes.some((mimeType) => mimeType.toLowerCase() === fileType);
  const extensionAllowed =
    !acceptedExtensions.length ||
    acceptedExtensions.some((extension) =>
      fileName.endsWith(extension.toLowerCase())
    );

  return mimeTypeAllowed && extensionAllowed;
};
